<ng-container *ngIf="!isMobileRender">
  <zip-co-header></zip-co-header>
</ng-container>

<app-new-design-variant-v2 *ngIf="!isLoading"
  [giftCard]="giftCard"
  [cardAvailability]="giftCard.cardTypeStatus === 'AVAILABLE'"
  [isMobileRender]="isMobileRender"
  (back)="continueShopping()"
  (continueShopping)="continueShopping()"
  (checkout)="initiateCheckout($event)"
  [browseCards]="browseGiftCards"
  [(buyType)]="buyType"
></app-new-design-variant-v2>

<ng-container *ngIf="!isMobileRender">
  <app-footer></app-footer>
</ng-container>

<ng-container *ngIf="isMobileRender">
  <app-mobile-footer (back)="back()"></app-mobile-footer>
</ng-container>
